import { useTranslation } from 'react-i18next'

import { mcpServerUrl } from '@/features/workspace/settings/mcp'
import { CopyButton } from '@/shared/components/copy-button'
import { getRuntimeConfig } from '@/shared/config/runtime'
import { Button } from '@/shared/ui/button'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/shared/ui/dialog'
import { Input } from '@/shared/ui/input'

/**
 * How a template is made: by an AI client over MCP, never from this app. The
 * dialog only hands over the address to connect one.
 */
export function CreateTemplateDialog({
  open,
  onOpenChange,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
}) {
  const { t } = useTranslation()
  const url = mcpServerUrl(getRuntimeConfig().publicBackendUrl, window.location.origin)

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('templates.create.title')}</DialogTitle>
          <DialogDescription>{t('templates.create.description')}</DialogDescription>
        </DialogHeader>

        <ol className="list-decimal space-y-3 pl-5 text-sm">
          <li className="space-y-2">
            <p>{t('templates.create.connect')}</p>
            <div className="flex items-center gap-2">
              <Input
                readOnly
                value={url}
                aria-label={t('templates.create.url')}
                className="h-8 font-mono"
              />
              <CopyButton value={url} label={t('mcpServer.copy')} />
            </div>
          </li>
          <li>{t('templates.create.ask')}</li>
        </ol>

        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">{t('action.close')}</Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
